module.exports = __webpack_public_path__ + "static/media/Analyis-Red.4487dd18.svg";